import {
  ACIN_AZORES_LOCATION,
  ACIN_LISBON_LOCATION,
  ACIN_MADEIRA_LOCATION,
  ACIN_PORTO_LOCATION,
} from "configs/links";
import { TFunction } from "i18next";
import { Address } from "./interfaces";

export const getAddresses = (t: TFunction): Array<Address> => [
  {
    district: t("3488") /* Lisboa */,
    addressComponents: [
      "ACIN iCloud Solutions",
      "Rua Domingos Monteiro",
      "Nº 7 A",
      `1050-074 ${t("3488") /* Lisboa */}`,
    ],
    mapUrl: ACIN_LISBON_LOCATION,
  },
  {
    district: t("3684") /* Porto */,
    addressComponents: [
      "ACIN iCloud Solutions",
      "Tecmaia",
      "Rua Eng. Frederico Ulrich, 2650",
      "4470-605 - Maia",
    ],
    mapUrl: ACIN_PORTO_LOCATION,
  },
  {
    district: t("6069") /* Madeira */,
    addressComponents: [
      "ACIN iCloud Solutions",
      "Estrada Regional, 104 Nº 42-A",
      "9350-203",
      `Ribeira Brava - ${t("6069") /* Madeira */}`,
    ],
    mapUrl: ACIN_MADEIRA_LOCATION,
  },
  {
    district: t("6070") /* Açores */,
    addressComponents: [
      "ACIN iCloud Solutions",
      "Rua da Alegria, nº 101",
      "9500-157",
      `Ponta Delgada - ${t("6070") /* Açores */}`,
    ],
    mapUrl: ACIN_AZORES_LOCATION,
  },
];
